module.exports = __webpack_public_path__ + "img/result_6.53fd4ad4.png";